<template>
    <div class="relative z-30" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <div class="fixed inset-0 bg-black bg-opacity-25 backdrop-blur-sm transition-opacity"></div>
        <div class="fixed inset-0 z-30 overflow-y-auto">
            <div class="flex min-h-full items-end px-2 pt-1 pb-16 text-center max-w-lg mx-auto">
                <div class="border-2 border-jackpot-bg flex-1 relative transform overflow-hidden rounded-lg text-left drop-shadow-xl transition-all">
                    <div class="bg-white dark:bg-global-bg p-4 modalheight overflow-y-auto">
                        <div class="text-center">
                            <h3 class="text-lg font-medium leading-6 text-gray-900 dark:text-gray-50">Deposit SOL</h3>
                            <p class="mt-2 text-blue-600 dark:text-blue-300 text-sm">It may take up to <span class="font-bold underline underline-offset-2 decoration-white">3 minutes</span> to be confirmed and available in your balance.</p>
                            <p class="text-gray-600 dark:text-gray-200 text-sm">If it doesn't show up in your balance, double check the transaction in solscan.</p>
                            <p class="text-gray-600 dark:text-gray-200 text-sm">Contact team in discord if needed.</p>

                            <div class="mt-4">
                                <div v-if="fetching" class="text-black dark:text-white flex flex-col items-center justify-center gap-2">
                                    <spinner />
                                    <div class="text-xs text-gray-800 dark:text-gray-200">Fetching balance...</div>
                                </div>

                                <div v-if="! fetching && !depositing">
                                    <div class="text-gray-600 dark:text-gray-200 text-sm flex items-center justify-center gap-2">
                                        <div>Wallet Balance:</div>
                                        <div @click="fillAmount" class="font-semibold text-blue-600 dark:text-inner-border">{{ humanBalance }} SOL</div>
                                        <div @click="getBalance">
                                            <i class="fa-regular fa-rotate-right"></i>
                                        </div>
                                    </div>
                                    <input v-model="amount" maxlength="20" min="0" type="number" class="mt-1 block text-sm text-black w-full rounded border border-gray-400 p-2 outline-none focus-none sm:text-sm" placeholder="Amount to deposit..." />
                                    <div v-if="checkDepositValue" class="text-red-600">Insufficient funds</div>
                                </div>

                                <div v-if="depositing" class="flex flex-col items-center gap-2 justify-center" :class="action_color == 'green' ?  'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'">
                                    <div v-text="action_message"></div>
                                    <spinner />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-gray-50 dark:bg-global-bg px-4 py-3 flex flex-col">
                        <button
                            @click.prevent="submit" :disabled="invalidInput || checkDepositValue || depositing || fetching"
                            type="button"
                            class="modal-action-button"
                        >Deposit</button>
                        <button
                            @click.prevent="close"
                            :disabled="depositing"
                            type="button"
                            class="modal-cancel-button"
                        >Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Connection, Transaction, SystemProgram, PublicKey } from '@solana/web3.js'
import { useWallet } from 'solana-wallets-vue'
import solana from '../../mixins/solana'

export default {
    name: 'DepositModal',
    mixins: [ solana ],
    props: ['account', 'token'],
    data() {
        return {
            rpc: process.env.MIX_SOLANA_RPC,
            solana_wallet: process.env.MIX_SOLANA_WALLET,
            balance: '',
            connection: null,
            fetching: false,
            depositing: false,
            amount: '',
            action_message: '',
            action_color: ''
        }
    },
    mounted() {
        this.connection = new Connection(this.rpc)
        this.getBalance()
    },
    computed: {
        humanBalance() {
            return this.lamportsToSol(this.balance)
        },
        invalidInput() {
            return this.amount == '' || this.amount <= 0
        },
        checkDepositValue() {
            return this.amount * 1000000000 > this.balance
        },
        lamportsAmount() {
            return this.amount * 1000000000
        }
    },
    methods: {
        fillAmount() {
            this.amount = this.humanBalance
        },
        async getBalance() {
            this.fetching = true
            try {
                const result = await this.connection.getBalance(useWallet().publicKey.value)
                this.balance = result
            } catch (err) {
                this.$toast.error(err.message)
            } finally {
                this.fetching = false
            }
        },
        async submit() {
            if (this.checkDepositValue) {
                return
            }
            this.depositing = true
            this.action_message = "Approve transaction."
            this.action_color = 'green'

            try {
                let tx = new Transaction()

                tx.add(
                    SystemProgram.transfer({
                        fromPubkey: useWallet().publicKey.value,
                        toPubkey: new PublicKey(this.solana_wallet),
                        lamports: this.lamportsAmount,
                    })
                )

                const { sendTransaction } = useWallet()

                const signature = await sendTransaction(tx, this.connection, { preflightCommitment: 'finalized' })
                console.log('tx:', signature)

                this.action_message = "Sending transaction..."
                this.action_color = 'green'

                let data = {
                    'amount': this.lamportsAmount,
                    'tx': signature,
                }

                await window.axios.post('/api/account/deposit', data, {
                    headers: {
                        'Authorization': `Bearer ${this.token}`
                    }
                })

                this.depositing = false
                this.amount = ''
                this.$toast.success('Your balance will be updated shortly.')
                this.close()
            } catch (err) {
                this.$toast.error(err.message)
            } finally {
                this.action_message = ''
                this.action_color = ''
                this.depositing = false
            }
        },
        close() {
            if (this.depositing) {
                return
            }
            this.emitter.emit('close-modal', 'deposit_modal')
        }
    }
}
</script>
